
		
				/** @jsx CsApp3.Core.createPureElement */
				/** @jsxFrag CsApp3.Core.createPureFragment */
			
		{
		
			let appNs = CsApp3.get('elinkerApps/DefaultWebTemplate');
			
			
		appNs.component('error_404.Renderer', class extends CsApp3.Core.PureComponent {
		
			constructor(props){
			
				super(props);
				
				this.appFrame = props._cs_config.appFrame;
			
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
				return(
					<>
					<div  {...{'className': 'notfound-page-wr'}}  {...{'data-cs-app-ns': 'elinkerApps/DefaultWebTemplate'}} >

	{' '}<div  {...{'className': 'notfound-page-body'}} >
		
		{' '}<div  {...{'className': 'row'}} >
			{' '}<div  {...{'className': 'col-md-6 center-content'}} >
				{' '}<img  {...{'alt': 'Error 404'}}  {...{'height': '219'}} {...{'src': this.utils.prefixize_url('assets/error_404/404-1.png')} } ></img>
			{' '}</div>
			
			{' '}<div  {...{'className': 'col-md-6 center-content '}} {...{'style': this.utils.prefixize_style('padding: 30px')} } >
				{' '}<span {...{'style': this.utils.prefixize_style('font-size: 30px;')} } >{"El sitio al que intentas acceder no puede ser encontrado... "}</span> 
			{' '}</div>
		{' '}</div>
		
		{' '}<div  {...{'className': 'info-box'}} >
			{' '}<p >
				{' '}<span {...{'style': this.utils.prefixize_style('font-size:20px;')} } >{"\n\t\t\t\t\t- Si has llegado hasta aqu\u00ed haciendo click en alg\u00fan enlace, por favor  cont\u00e1ctanos para que podamos revisar el error.\n\t\t\t\t"}</span>
			{' '}</p>
			{' '}<p >
				{' '}<span {...{'style': this.utils.prefixize_style('font-size:20px;')} } >{"\n\t\t\t\t\t- \u00bfEst\u00e1s seguro de que has escrito bien la direcci\u00f3n?\n\t\t\t\t"}</span>
			{' '}</p>
		{' '}</div>
	
	{' '}</div>
	
{' '}</div>
					</>
				);
			} 
			
		});
		
			
		}